/*
 *
 * LanguageProvider constants
 *
 */
const CHANGE_LOCALE = 'app/LanguageProvider/CHANGE_LOCALE';
export default CHANGE_LOCALE;



// WEBPACK FOOTER //
// ./app/containers/language-provider/constants.js